export enum AppType {
  Direct = 'direct',
  Agent = 'agent',
  TravelAgency = 'travelAgency',
}
